import {
  Flex,
  FormControl,
  Text,
  Input,
  Icon,
  FormLabel,
  Button,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  useUpdateAccountSettingsMutation,
  useGetAccountSettingsQuery,
} from '../api/authApi'
import { useLogout } from '../../../app/hooks/useLogout'
import { FaUserEdit } from 'react-icons/fa'

export const ResetUsernameEmail = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const { data } = useGetAccountSettingsQuery()
  const [updateAccountSettings] = useUpdateAccountSettingsMutation()
  const logout = useLogout()

  useEffect(() => {
    if (data) {
      setName(data.full_name)
      setEmail(data.email)
    }
  }, [data])

  const handleSave = async () => {
    const toastId = toast.info('Saving...', {
      style: { padding: '10px 20px' },
      autoClose: false,
      isLoading: true,
      progress: undefined,
    })
    try {
      await updateAccountSettings({ full_name: name, email })
      toast.update(toastId, {
        render: 'Changes saved successfully!',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })
      logout()
    } catch {
      toast.update(toastId, {
        render: `Failed to save changes`,
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    }
  }

  return (
    <>
      <Flex direction="column" alignItems="center">
        <Icon as={FaUserEdit} w={12} h={12} color="#157FEE" />
        <Text as="h2" fontSize={{ base: 'xl', sm: '2xl' }} fontWeight="bold" mt={6}>
          Change your username and email
        </Text>
      </Flex>
      <FormControl mb={4}>
        <FormLabel>Username</FormLabel>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="New username"
        />
      </FormControl>

      <FormControl>
        <FormLabel>Email</FormLabel>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="New email"
        />
      </FormControl>

      <Button
        mt={4}
        colorScheme="blue"
        onClick={handleSave}
        disabled={!name || !email}
        mx="auto"
        display="block"
      >
        Save Changes
      </Button>
    </>
  )
}

export default ResetUsernameEmail
